import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import CreateSaq from "../../components/CreateSaq";
// import CompletedSaqs from "../../components/CompletedSaqs";

import { images } from "../../helpers/images";

// import logo from "../../static/images/tg-logo.svg";

import {
  callApiSaqsFind,
  callApiDownloadSaqPdf,
  callApiUpdateUserPassword,
} from "../../services";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import { authUserData } from "../../helpers";
import Header from "../../components/Header";
import DeleteConfirmationModal from "../../components/modals/DeleteConfirmationModal";

import { fetchWhiteLabelBusinessUsers } from "../../modules/actions/";

class whiteLabelControlPanel extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = { subdomain: "" };
  }

  componentDidMount = async () => {
    let hostData = window.location.host.split(".");

    if (hostData && hostData.length !== 3) {
      // window.location.href = "http://saqgenerator.local/white-label/signup";
    } else {
      this.setState({
        subdomain: window.location.host.split(".")[0],
      });
    }

    this.props.fetchWhiteLabelBusinessUsers(this.state.subdomain);
  };

  componentDidUpdate(prevState, prevProps) {
    console.log(prevProps);
  }

  render() {
    return (
      <>
        <div className="cell small-12 medium-10" id="maincontent">
          {/* <Header /> */}
          <div id="body-content">
            <div className="grid-x grid-margin-x grid-margin-y">
              <div className="cell small-12 medium-12" id="completedsaqs">
                <h3>Users</h3>
                <br />
                <div id="compltedsaqs-table">
                  <table>
                    <thead>
                      <tr>
                        <th width="200">Webiste</th>
                        <th width="150">Last Updated</th>
                        <th width="150">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td colSpan="3">No records.</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    res: state.authStore.res,
  };
};
const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({ fetchWhiteLabelBusinessUsers }, dispatch);
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(whiteLabelControlPanel);
